<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div class="div_loading">
        <div class="my-container" [hidden]="!loading">
            <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
        </div>
    </div>
    <div mat-dialog-title class="matDialogTitle" cdkDragHandle>
        واحد اندازه گیری
        <span class="close" (click)="close()">
            <mat-icon>close</mat-icon>
        </span>
    </div>
</div>


<div mat-dialog-content class="matDialogContent">
    <div class="row">
        <form [formGroup]="form1">
            <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> واحد اندازه گیری : </span>
                    <span (click)="reset_input(218)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class='wh-input' formControlName="weight_title" autocomplete="off"
                        (click)="load_services(218)" required (keyup.enter)="update()" readonly>
                    <input class='wh-input' formControlName="weight" autocomplete="off" [hidden]="true" readonly>
                </label>
            </div>

            <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1">مقدار : </span>
                    <input class='wh-input' formControlName="amount" (keyup.enter)="update()" autocomplete="off"
                        required>
                </label>
            </div>
        </form>
    </div>
</div>

<div mat-dialog-actions class="matDialogActions">
    <button class="btn_pe" (click)="update()" [disabled]="!form1.valid">
        اضافه کردن
    </button>
</div>